// extracted by mini-css-extract-plugin
module.exports = {"root":"ResidentMedications_root__2PMBO","tabicon":"ResidentMedications_tabicon__315Gi"};